import React, { forwardRef, useId } from 'react';
import { cx } from '../utils';
import './Checkbox.css';

// Qolgan prop'lar (name, checked, onChange, value ...) <input type="checkbox"> ga uzatiladi.
const Checkbox = forwardRef(function Checkbox(
  { id, label, disabled, className, wrapperClassName, ...rest },
  ref
) {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <div className={cx('ui-checkbox', disabled && 'ui-checkbox--disabled', wrapperClassName)}>
      <input
        {...rest}
        ref={ref}
        id={inputId}
        type="checkbox"
        disabled={disabled}
        className={cx('ui-checkbox__input', className)}
      />
      {label && (
        <label htmlFor={inputId} className="ui-checkbox__label">
          {label}
        </label>
      )}
    </div>
  );
});

export default Checkbox;
